// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__27AxR","avatar":"Panel_avatar__2zLWH","brand":"Panel_brand__3lsQ7","btns":"Panel_btns__Yn8Qr","level":"Panel_level__3HwxH","counter":"Panel_counter__x2iMl"};